import {Link} from "react-router-dom";


/**
 * 아카이브 > 연도별 조선제학교 일람 정보 > 리스트 아이템
 * @param data
 * @param onTocClick
 * @param onInfoClick
 * @returns {JSX.Element}
 *
 */
const ColonicalSchoolItem = ({data, onTocClick, onInfoClick}) => {

    // bookId 전달하기 - 전달받은 목차에서 데이터 뿌리기
    const handleToc = (bookId) => {
        onTocClick(bookId);
    }

    // year 전달하기
    const handleInfo = (year) => {
        onInfoClick(year);
    }

    return (
        <>
            {
                data.map((book, index) => (

                            <div className="list-row" key={index}>
                                <Link to={'#'} onClick={() => handleToc(book.book_id)} className="row-link">
                                    <div className="year c-black">{book.numeration}</div>
                                    <div className="title bold c-black">{book.book_title}</div>
                                    <div className="title-ko">{book.book_title_ko} {book.numeration}년도</div>
                                    <div className="date">{book.publish_date}</div>
                                </Link>
                                <button type="button" className="btn-info"
                                        onClick={() => handleInfo(book.numeration)}>정보보기
                                </button>

                    </div>
                ))
            }
        </>
    )
}

export default ColonicalSchoolItem;